
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Options` type.
 */

type Options = {
  locale: string
};

/**
 * Export `fetchDistricts`.
 */

export async function fetchDistricts({ locale }: Options) {
  const endpoint = getApiEndpoint('getDistricts');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
